import script from "./myorders.vue?vue&type=script&setup=true&lang=js"
export * from "./myorders.vue?vue&type=script&setup=true&lang=js"

import "./myorders.vue?vue&type=style&index=0&id=26a7cf12&scoped=true&lang=css"

import exportComponent from "F:\\proj-abhinav\\meraki\\patient-portal-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26a7cf12"]])

export default __exports__